import queryString from 'query-string';
import {putOptionsInQueryString} from 'utils';

export const getServiceUrl = (service, url) => {
    switch (service) {
        case 'facebook':
            return `https://www.facebook.com/sharer/sharer.php?u=${url}`;
        case 'twitter':
            return `https://twitter.com/home?status=${url}`;
        case 'google':
            return `https://plus.google.com/share?url=${url}`;
        case 'linkedin':
            return `https://www.linkedin.com/shareArticle?mini=true&url=${url}`;
        case 'email':
            return `mailto:?subjet=${document.title}&body=${url}`;
        default:
            throw new Error(`Unknown service "${service}"`);
    }
};

export const getShareOptions = (config) => {
    const options = {
        wrapperId: config.get('wrapperId'),
    };

    if (config.get('shareTime')) {
        options.startTime = config.get('startTime');
    }

    if (config.get('shareSearch')) {
        options.searchQuery = config.get('searchQuery');
        options.searchTypes = config.get('searchTypes').join(',');
        options.searchPartial = config.get('searchPartial');
    }

    return options;
};

export const getShareUrl = (config) => {
    let url = `${window.location.origin}${window.location.pathname}`;

    const shareOptions = getShareOptions(config);
    let qs = putOptionsInQueryString(shareOptions, window.location.search);

    // Remove restricted querystring keys available inside the Portfolio
    const restricted = ['apiUrl', 'apiToken'];
    qs = Object.entries(qs).reduce((values, [key, value]) => {
        if (!restricted.includes(key)) values[key] = value;
        return values;
    }, {});

    qs = queryString.stringify(qs);
    if (qs) url += `?${qs}`;

    if (window.location.hash) url += window.location.hash;
    return encodeURI(url);
};

export const openShareWindow = (service, shareUrl) => {
    const url = getServiceUrl(service, shareUrl);
    const size = [550, 420];
    const left = (window.screen.width - size[0]) / 2;
    const top = (window.screen.height - size[1]) / 2;
    const params = [
        `left=${left}`,
        `top=${top}`,
        `width=${size[0]}`,
        `height=${size[1]}`,
        'toolbar=0',
        'menubar=0',
        'scrollbars=0',
        'location=0',
    ].join(',');

    const shareWindow = window.open(url, '_blank', params);
    shareWindow.focus();
};



// WEBPACK FOOTER //
// ./scripts/share.js